import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["classes", "text", "size", "type", "icon", "href", "iconType", "theme", "disabled", "onClick", "buttonType", "loadingText", "form"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useState } from 'react';
import Link from 'next/link';
import useIsMounted from '../../../hooks/useIsMounted';
import { Icon } from '../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Button = function Button(_ref) {
  var classes = _ref.classes,
      text = _ref.text,
      size = _ref.size,
      type = _ref.type,
      icon = _ref.icon,
      href = _ref.href,
      iconType = _ref.iconType,
      theme = _ref.theme,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      _ref$buttonType = _ref.buttonType,
      buttonType = _ref$buttonType === void 0 ? 'submit' : _ref$buttonType,
      loadingText = _ref.loadingText,
      form = _ref.form,
      rest = _objectWithoutProperties(_ref, _excluded);

  var isMounted = useIsMounted();

  var _useState = useState(false),
      isLoading = _useState[0],
      setIsLoading = _useState[1];

  var onClickHandler = function onClickHandler(event) {
    if (!(onClick instanceof Function)) {
      return;
    }

    setIsLoading(true);
    var clickResult = onClick(event);

    if (clickResult instanceof Promise) {
      clickResult["finally"](function () {
        if (isMounted.current) setIsLoading(false);
      });
    } else {
      setIsLoading(false);
    }
  };

  var isDisabled = disabled || isLoading;
  var baseStyle = generateStyles({
    type: type,
    size: size,
    disabled: isDisabled,
    theme: theme,
    classes: classes
  });

  if (href) {
    return /*#__PURE__*/_jsx(Link, {
      href: href,
      children: /*#__PURE__*/_jsxs("a", _objectSpread(_objectSpread({
        className: baseStyle
      }, rest), {}, {
        children: [icon && /*#__PURE__*/_jsx(Icon, {
          type: iconType,
          name: icon,
          size: "sm",
          className: "mr-1.5"
        }), text]
      }))
    });
  }

  return /*#__PURE__*/_jsxs("button", _objectSpread(_objectSpread({
    type: buttonType,
    className: baseStyle,
    onClick: onClickHandler,
    disabled: isDisabled,
    form: form
  }, rest), {}, {
    children: [icon && /*#__PURE__*/_jsx(Icon, {
      type: iconType,
      name: icon,
      size: "sm",
      className: "mr-1.5"
    }), isLoading ? loadingText : text]
  }));
};
Button.defaultProps = {
  size: 'md',
  type: 'primary',
  iconType: 'regular',
  theme: 'default',
  disabled: false,
  loadingText: 'Loading'
};

var getColors = function getColors(type, theme) {
  switch (theme) {
    case 'default':
      return type === 'primary' ? 'bg-subkit-primary text-white border-subkit-primary' : 'text-black hover:border-subkit-primary hover:text-subkit-primary';

    case 'danger':
      return type === 'primary' ? 'bg-subkit-red text-white border-subkit-red' : 'text-black hover:border-subkit-red hover:text-subkit-red';

    default:
      break;
  }
};

var generateStyles = function generateStyles(_ref2) {
  var type = _ref2.type,
      size = _ref2.size,
      disabled = _ref2.disabled,
      theme = _ref2.theme,
      classes = _ref2.classes;
  var baseStyle = "flex flex-shrink-0 justify-center items-center border font-medium font-sans text-base rounded focus:outline-none ".concat(classes);
  var primaryClassNames = disabled ? 'bg-gray-300 text-white border-gray-300 disabled' : "".concat(getColors(type, theme));
  var secondaryClassNames = disabled ? 'text-gray-200 disabled' : "".concat(getColors(type, theme));

  switch (type) {
    case 'primary':
      baseStyle = "".concat(baseStyle, " ").concat(primaryClassNames, " hover:shadow-lg");
      break;

    case 'secondary':
      baseStyle = "".concat(baseStyle, " ").concat(secondaryClassNames, " bg-transparent ").concat(disabled ? 'border-gray-200' : 'border-gray-400');
      break;

    case 'warning':
      baseStyle = "".concat(baseStyle, " bg-red-700 border-red text-white hover:shadow-lg");
      break;

    default:
      break;
  }

  switch (size) {
    case 'lg':
      baseStyle = "".concat(baseStyle, " w-full py-2");
      break;

    case 'md':
      baseStyle = "".concat(baseStyle, " py-2 px-8");
      break;

    case 'sm':
      baseStyle = "".concat(baseStyle, " py-1.5 px-4");
      break;

    default:
      break;
  }

  return baseStyle;
};